import { z } from 'zod';
import { customerLicenseFormSchema } from './form.js';
import { isBlankCustomerLicenseForm } from './is-blank-customer-license-form.js';
/** New Customer's license: left blank it passes, and once any field is filled it must be a whole license. */
export const optionalCustomerLicenseFormSchema = z
    .custom()
    .superRefine((values, context) => {
    if (isBlankCustomerLicenseForm(values))
        return;
    const result = customerLicenseFormSchema.safeParse(values);
    for (const issue of result.error?.issues ?? []) {
        context.addIssue({ code: 'custom', message: issue.message, path: issue.path });
    }
});
//# sourceMappingURL=optional-customer-license-form.js.map